import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CalendarBadge } from '@/components/ui/calendar-badge';
import { getCalendarBadgeParts } from '@/lib/date';
import type { KeyEvent } from './types';

type Props = {
  events: KeyEvent[];
};

export function ReviewKeyEvents({ events }: Props) {
  if (events.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle headingLevel="h3">Eventi chiave</CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="space-y-0">
          {[...events].sort((a, b) => a.date.localeCompare(b.date)).map((event, i) => {
            const parsedDate = getCalendarBadgeParts(event.date);
            const isLast = i === events.length - 1;
            return (
              <li
                key={i}
                className={`flex gap-3 py-4 ${!isLast ? 'border-b border-border' : ''}`}
              >
                {parsedDate ? (
                  <CalendarBadge day={parsedDate.day} month={parsedDate.month} />
                ) : (
                  <span className="text-muted-foreground text-xs shrink-0">{event.date}</span>
                )}
                <div className="flex-1 min-w-0">
                  <p className="text-sm leading-relaxed">{event.description}</p>
                  {event.clinical_relevance ? (
                    <p className="text-xs mt-2 rounded-md bg-primary/5 text-primary px-2 py-1.5 inline-block">
                      {event.clinical_relevance}
                    </p>
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
}
